<div class="flex-column gap-L">
	<div class="font-MM fw-700">{{ 'page.workstation.resources'|translate }}</div>
	<div class="resource-card pad-M flex-space-between flex-align-center">
		<div class="flex-align-center gap-XS">
			<div class="resource-icon-bubble flex-center" [class.resource-ok]="workstation.cpuUsed < 70" [class.resource-warning]="workstation.cpuUsed >= 70 && workstation.cpuUsed < 90" [class.resource-error]="workstation.cpuUsed >= 90">
				<img src="assets/icons/cpu-chip-01.svg" class="filter-white">
			</div>
			<div class="flex-column" style="gap: 2px;">
				<span class="fw-700 font-M">
					{{ workstation.cpuUsed }}%
				</span>
				<span class="font-S grey">
					{{ 'page.workstation.cpuUsed' | translate }}
				</span>
			</div>
		</div>
		<div class="flex-align-center gap-XS">
			<div class="resource-icon-bubble flex-center" [class.resource-ok]="workstation.ramUsed < 85" [class.resource-warning]="workstation.ramUsed >= 85 && workstation.ramUsed < 95" [class.resource-error]="workstation.ramUsed >= 95">
				<img src="assets/icons/ram.svg" class="filter-white">
			</div>
			<div class="flex-column" style="gap: 2px;">
				<span class="fw-700 font-M">
					{{ workstation.ramUsed }}%
				</span>
				<span class="font-S grey">
					{{ 'page.workstation.ramUsed' | translate }}
				</span>
			</div>
		</div>
		<div class="flex-align-center gap-XS">
			<div class="resource-icon-bubble flex-center" [class.resource-undefined]="!workstation.storageUsed" [class.resource-ok]="workstation.storageUsed && workstation.storageUsed < 70" [class.resource-warning]="workstation.storageUsed && workstation.storageUsed >= 70 && workstation.storageUsed < 90" [class.resource-error]="workstation.storageUsed && workstation.storageUsed >= 90">
				<img src="assets/icons/hard-drive.svg" class="filter-white">
			</div>
			<div class="flex-column" style="gap: 2px;">
				<span class="fw-700 font-M">
					{{ workstation.storageUsed ? workstation.storageUsed + '%' : '-' }}
				</span>
				<span class="font-S grey">
					{{ 'page.workstation.storageUsed' | translate }}
				</span>
			</div>
		</div>
		<div class="flex-align-center gap-XS">
			<div class="resource-icon-bubble flex-center" [class.resource-undefined]="!workstation.batteryHealth" [class.resource-ok]="workstation.batteryHealth && workstation.batteryHealth > 90" [class.resource-warning]="workstation.batteryHealth && workstation.batteryHealth >= 70 && workstation.batteryHealth <= 90" [class.resource-error]="workstation.batteryHealth && workstation.batteryHealth < 70">
				<img src="assets/icons/battery-charging-01.svg" class="filter-white">
			</div>
			<div class="flex-column" style="gap: 2px;">
				<span class="fw-700 font-M">
					{{ workstation.batteryHealth ? workstation.batteryHealth + '%' : '-' }}
				</span>
				<span class="font-S grey">
					{{ 'page.workstation.batteryHealth' | translate }}
				</span>
			</div>
		</div>
	</div>
</div>


